import React from "react";
import * as m from "../lib/model";
import { Upload, FileText, ShoppingCart, Repeat, Landmark, ScrollText, RefreshCcw, Settings2, Layers, GitFork, GitMerge, Receipt, SlidersHorizontal, ListOrdered, Activity, ArrowLeftRight, Ruler, Gauge, CalendarClock, Percent, Wallet, TrendingUp, TrendingDown, LineChart, PiggyBank } from "lucide-react";

const ICONS = {
  "deal-info": FileText, "upload-parse": Upload, "txn-bar": ArrowLeftRight, "card-purchase": ShoppingCart, "recap-card": Repeat,
  "card-slb": Landmark, "card-rent": Ruler, "card-seller-note": ScrollText, "card-rollover": RefreshCcw,
  "card-operating": Settings2, "sec-operations": Gauge, "sec-hold-exit": CalendarClock, "sec-mgmt-fee": Percent,
  "blend-card": Layers, "working-capital": Wallet, "rollup-terms": GitMerge, "lp-terms": GitFork, "distribution": PiggyBank, "transaction-costs": Receipt, "sec-fees-costs": Wallet, "sec-placement": Percent,
  "scenario-assumptions": SlidersHorizontal, "sec-upside": TrendingUp, "sec-downside": TrendingDown, "live-preview": LineChart,
};

export function AssumptionsRail({ M, sections, active, onSelect }) {
  const ex = m.exitReturns(M), wf = m.lpWaterfall(M), d1 = m.dscrYr1(M);
  const pct = (v) => (Number.isFinite(v) && Math.abs(v) < 1000 ? m.fmtPct(v) : "n/a");
  const x = (v) => (Number.isFinite(v) && Math.abs(v) < 1000 ? m.fmtX(v) : "n/a");
  let n = 0;
  return (
    <aside className="asmp-rail" data-testid="asmp-rail">
      <div className="rail-title"><ListOrdered size={12} /> Hyperlinks to input sections</div>
      <nav className="rail-nav">
        {sections.map((s) => {
          const Icon = ICONS[s.id] || FileText;
          if (!s.sub) n += 1;
          const on = s.sub ? false : active === s.id;
          const inGroup = s.sub && active === s.parent;
          return (
            <button key={s.id} className={`rail-link ${s.sub ? "sub" : ""} ${on ? "active" : ""} ${inGroup ? "ingroup" : ""}`} onClick={() => onSelect(s)} data-testid={`rail-${s.id}`}>
              <span className="rail-num">{s.sub ? "" : n}</span><Icon size={s.sub ? 11 : 13} className="rail-ico" /><span className="rail-lbl">{s.label}</span>
            </button>
          );
        })}
      </nav>
      <div className="rail-foot">
        <div className="rail-title" style={{ paddingTop: 10 }}><Activity size={12} /> Key metrics · live</div>
        <div className="rail-metrics" data-testid="rail-metrics">
          <div><span>Equity IRR</span><b className={ex.irr >= 20 ? "pos" : ""}>{pct(ex.irr)}</b></div>
          <div><span>Equity MOIC</span><b>{x(ex.moic)}</b></div>
          <div><span>DSCR Yr 1</span><b className={d1 >= 1.25 ? "pos" : "neg"}>{x(d1)}</b></div>
          <div><span>LP IRR</span><b>{pct(wf.lpIrr)}</b></div>
          <div><span>LP MOIC</span><b>{x(wf.lpMoic)}</b></div>
          <div><span>Equity ask</span><b>{m.fmt$(ex.lpAsk)}</b></div>
        </div>
      </div>
    </aside>
  );
}
